export { default } from "./Dashboard";

export const BASE_DASHBOARD_PATH = "dashboard";
